export const company = {
  name: 'Lumumbashi Minerals SPRL',
  shortName: 'Lumumbashi Minerals',
  established: 2010,
  ceo: 'Abdul Hasan',
  email: 'sales@lumumbashiminerals.com',
  whatsapp: '+254797503430',
  whatsappDigits: '254797503430',
  phone: '+254 797 503 430',
  logo: 'https://cdn.magicpatterns.com/uploads/pomAEDJ1fa5CEzMsvvMrK3/C792C897-B732-4D16-8607-F204F68F9A79-removebg-preview.png',
  offices: [
    {
      label: 'Head Office — Lubumbashi',
      lines: ['Lubumbashi, Haut-Katanga', 'Democratic Republic of Congo'],
    },
    {
      label: 'Trading Office — Butembo',
      lines: ["Av. Bungulu N'11, Ville de Butembo", 'Nord Kivu, Democratic Republic of Congo'],
    },
  ],
  hours: 'Monday – Saturday, 07:30 – 19:00 (CAT)',
  images: {
    hero: 'https://cdn.magicpatterns.com/patterns/generated-images/d710f9da-2d47-4da2-940a-a3ef655efce7.jpg',
    logistics: 'https://cdn.magicpatterns.com/patterns/generated-images/30d5e36f-ac9b-4ee3-a780-cfcbf49fff19.jpg',
    ceo: 'https://cdn.magicpatterns.com/patterns/generated-images/f2a97f3f-0071-4c8d-8ba8-5e475aa2ce04.jpg',
    lab: 'https://cdn.magicpatterns.com/patterns/generated-images/a0bf73d1-2e67-4869-bf8c-2d25ecb7ab21.jpg',
  },
  stats: [
    { value: '2010', label: 'Established in Lubumbashi' },
    { value: '38', label: 'Export destination countries' },
    { value: '14,600 t', label: 'Copper units shipped in 2025' },
    { value: '99.4%', label: 'On-time vessel loading' },
  ],
  primaryCountries: [
    {
      name: 'Democratic Republic of Congo',
      flag: 'https://flagcdn.com/w160/cd.png',
      note: 'Head office in Lubumbashi and trading desk in Butembo. Copper, cobalt-bearing concentrates, gold, diamonds and gemstones.',
    },
    {
      name: 'Zambia',
      flag: 'https://flagcdn.com/w160/zm.png',
      note: 'Copperbelt sourcing and bonded transit through Ndola and Kasumbalesa for cathode and concentrate cargo.',
    },
  ],
  eastAfrica: [
    { name: 'Kenya', flag: 'https://flagcdn.com/w80/ke.png' },
    { name: 'Tanzania', flag: 'https://flagcdn.com/w80/tz.png' },
    { name: 'Uganda', flag: 'https://flagcdn.com/w80/ug.png' },
    { name: 'Rwanda', flag: 'https://flagcdn.com/w80/rw.png' },
    { name: 'Burundi', flag: 'https://flagcdn.com/w80/bi.png' },
    { name: 'South Sudan', flag: 'https://flagcdn.com/w80/ss.png' },
    { name: 'Ethiopia', flag: 'https://flagcdn.com/w80/et.png' },
    { name: 'Somalia', flag: 'https://flagcdn.com/w80/so.png' },
  ],
  certifications: [
    'ITSCI member — mineral traceability',
    'LME Grade A registered cathode supply',
    'Kimberley Process certificate on every rough parcel',
    'SGS / Alfred H. Knight independent assay',
    'CEEC & ARECOMS export documentation',
  ],
  timeline: [
    {
      year: '2010',
      title: 'Founded in Lubumbashi',
      text: 'Registered as an SPRL trading copper concentrates from artisanal and semi-industrial sites across Haut-Katanga.',
    },
    {
      year: '2013',
      title: 'First refined metal exports',
      text: 'Began direct gold and silver dore shipments to refiners in Dubai and Switzerland under full assay verification.',
    },
    {
      year: '2016',
      title: 'Butembo trading desk',
      text: "Opened the Nord Kivu office at Av. Bungulu N'11 to source rough diamonds and coloured gemstones under Kimberley Process controls.",
    },
    {
      year: '2019',
      title: 'LME Grade A cathode programme',
      text: 'Secured long-term offtake with Katangan electro-refineries, supplying 99.99% Cu cathodes to Asian and European mills.',
    },
    {
      year: '2022',
      title: 'Integrated logistics',
      text: 'Bonded warehousing and sealed-container corridors via Kasumbalesa, Dar es Salaam, Durban and Mombasa.',
    },
    {
      year: '2026',
      title: 'Worldwide desk under CEO Abdul Hasan',
      text: 'Active buyer relationships across 38 countries with a dedicated contract and documentation team.',
    },
  ],
};
